import type { FormEvent } from 'react';

import {
  FormTextField,
  useFormField,
  useFormFieldsContext,
} from '@spotify/confidence-core-react';

import { MAX_CUSTOM_ROLE_LENGTH } from '../../config/onboardingSurvey';
import { OTHER_ROLE, type SurveyFormValues } from './surveyForm';

import styles from './OnboardingSurvey.module.css';

const focusOnMount = (input: HTMLElement | null) => input?.focus();

export const CustomRoleFormField = () => {
  const { value, setValue } = useFormField<SurveyFormValues, 'customRole'>(
    'customRole',
    '',
  );
  const { values } = useFormFieldsContext<SurveyFormValues>();

  if (values.role !== OTHER_ROLE) {
    return null;
  }

  return (
    <div className={styles.customRole}>
      <FormTextField
        ref={focusOnMount}
        label="Describe your role"
        name="customRole"
        maxLength={MAX_CUSTOM_ROLE_LENGTH}
        value={value}
        onChange={(event: FormEvent<HTMLInputElement>) =>
          setValue(event.currentTarget.value)
        }
       data-track-source-anchor="e36af41690"/>
    </div>
  );
};
